// BotpressProvider Events
// These events are send to inform useBotpress of changes
export var BOTPRESS_PROVIDER_LOADED_EVENT = 'botpress:loaded';
export var BOTPRESS_PROVIDER_CONVERSATION_EVENT = 'botpress:conversation';
export var BOTPRESS_PROVIDER_NAVIGATION_EVENT = 'botpress:navigation';

// Botpress Webchat Events
export var BOTPRESS_WEBCHAT_OPENED_EVENT = 'webchat:opened';
export var BOTPRESS_WEBCHAT_CLOSED_EVENT = 'webchat:closed';
export var BOTPRESS_GOOGLE_ANALYTICS_EVENT = 'glammatic:ga';
export var BOTPRESS_CONVERSATION_EVENT = 'conversation';
export var VARIANT_SOFT = 'soft';
export var VARIANT_SOLID = 'solid';
export var THEME_MODE_LIGHT = 'light';
export var THEME_MODE_DARK = 'dark';
var ADDITIONAL_STYLESHEET_URL_SANDBOX = 'https://files.bpcontent.cloud/2025/01/17/12/20250117122026-9WQL43NW.css';
var ADDITIONAL_STYLESHEET_URL_PRODUCTION = 'https://files.bpcontent.cloud/2025/01/31/14/20250131145659-62266MUM.css';
var ADDITIONAL_STYLESHEET_URL = process.env.FAST_ENV === 'production' ? ADDITIONAL_STYLESHEET_URL_PRODUCTION : ADDITIONAL_STYLESHEET_URL_SANDBOX;
export var BOTPRESS_DEFAULT_CONFIG = {
  composerPlaceholder: 'Ask something here!',
  botName: 'Customer service',
  botAvatar: '',
  botDescription: '',
  color: '',
  variant: VARIANT_SOFT,
  themeMode: THEME_MODE_LIGHT,
  additionalStylesheetUrl: ADDITIONAL_STYLESHEET_URL,
  fontFamily: undefined,
  radius: 4,
  email: {},
  phone: {},
  website: {},
  termsOfService: {},
  privacyPolicy: {},
  allowFileUpload: false
};
export var BOTPRESS_NOTIFICATION_CONTAINER_ID = 'botpress-notification-container';